import React, { useEffect, useState } from "react";
import "./Tickets.css"
import Modal from '../../../Components/Modal';
import { PageBase } from "../../../Components/PageBase";
import iconTickets from "../../../icons/ticket.svg"
import iconTicketsNH from "../../../icons/ticketNH.svg"
import iconSvg from "../../../icons/add-circle.svg";
import { useRol } from "../../../Context";
import { NavLink } from "react-router-dom";


function Soporte() {

    const {
        rol,
        tickets,
        setTickets,
        setTicket,
        crearTicket,
        titulo,
        setTitulo,
        descripcion,
        setDescripcion,
        tipo,
        setTipo,
        Id
    } = useRol();
    const [estilo, setEstilo] = useState({ width: '38%' });
    const [estilo2, setEstilo2] = useState({ width: '11%' });

    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => {
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setTickets(tickets)
        setIsModalOpen(false);
        document.body.style.overflow = 'visible';
        setTitulo('')
        setDescripcion('')
        setTipo('Error')
    };

    useEffect(() => {
        if (rol === 'Coordinador') {
            setEstilo({
                width: '26%'
            });
            setEstilo2({
                width: '7%'
            });
        }
    }, [rol]);

    const handleSubmit = () => {
        crearTicket()
        closeModal()
    };

    const [isHoveredProcess, setIsHoveredProcess] = useState(false);
    const [isHoveredOpen, setIsHoveredOpen] = useState(false);
    const [isHoveredClose, setIsHoveredClose] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        setTicket({
            title: titulo,
            description: descripcion,
            type_ticket: tipo,
            id_user: Id
        })
    }, [titulo, descripcion, tipo, setTicket, Id])

    return (
        <>
            <PageBase />
            <div className="main-content">
                <div className="margin-general-tickets">
                    <div className="container-inidicador-etapas">
                        <div className="card-indicador-ticket"
                            onMouseEnter={() => setIsHoveredProcess(true)}
                            onMouseLeave={() => setIsHoveredProcess(false)}>
                            <span>0</span>
                            <label><img
                                src={isHoveredProcess ? iconTickets : iconTicketsNH}
                                alt="Imagen" />
                                En proceso</label>
                        </div>
                        <div className="card-indicador-ticket"
                            onMouseEnter={() => setIsHoveredOpen(true)}
                            onMouseLeave={() => setIsHoveredOpen(false)}>
                            <span>0</span>
                            <label><img
                                src={isHoveredOpen ? iconTickets : iconTicketsNH}
                                alt="Imagen" />
                                Abierto</label>
                        </div>
                        <div className="card-indicador-ticket"
                            onMouseEnter={() => setIsHoveredClose(true)}
                            onMouseLeave={() => setIsHoveredClose(false)}>
                            <span>0</span>
                            <label><img
                                src={isHoveredClose ? iconTickets : iconTicketsNH}
                                alt="Imagen" />
                                Cerrado</label>
                        </div>
                        <div className="card-indicador-ticket"
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}>
                            <span>0</span>
                            <label><img
                                src={isHovered ? iconTickets : iconTicketsNH}
                                alt="Imagen" />
                                Pendiente</label>
                        </div>
                    </div>
                    <div className="table-tickets">
                        <div className="margin-table-tickets">
                            <button onClick={openModal}>
                                <img src={iconSvg} alt="+" />
                                <label>Agregar Tickets</label>
                            </button>
                            <table>
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>TITULO</th>
                                        <th style={estilo}>APERTURA</th>
                                        <th style={estilo2}>TIPO</th>
                                        {rol === 'Coordinador' && <th>USUARIO</th>}
                                        <th>ESTADO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tickets?.map((ticket, index) => (<tr key={index}>
                                        <td>19</td>
                                        <td>
                                            <NavLink to={'/Detalles-soporte'} className="nav-links">
                                                <span>{ticket.title}</span>
                                            </NavLink>
                                        </td>
                                        <td style={estilo}>14 de Febrero de 2024 a las 18:33</td>
                                        <td style={estilo2}>{ticket.type_ticket}</td>
                                        {rol === 'Coordinador' && <td>Alicia Martinez Esquivel</td>}
                                        {rol === 'Asesor' ? <td>Abierto</td> : <td><select>
                                            <option value="abierto">Abierto</option>
                                            <option value="cerrado">Cerrado</option>
                                            <option value="en proceso">En proceso</option>
                                            <option value="pendiente">Pendiente</option>
                                        </select></td>}
                                    </tr>))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <Modal isOpen={isModalOpen} onClose={closeModal}>
                <div className="modal-title">
                    <label>Crear Ticket</label>
                </div>
                <div className="container-main-modal" style={{ width: '500px', height: '430px', overflow: 'hidden' }}>
                    <form className="form-tickets-modal">
                        <label htmlFor="titulo">Titulo:</label>
                        <input
                            type="text"
                            id="titulo"
                            name="titulo"
                            value={titulo}
                            onChange={(e) => setTitulo(e.target.value)}
                            required
                        />
                        <label htmlFor="descripcion">Descripción:</label>
                        <textarea
                            id="descripcion"
                            name="descripcion"
                            rows="10"
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                            required
                        ></textarea>
                        <label htmlFor="tipo">Tipo:</label>
                        <select
                            id="tipo"
                            name="tipo"
                            value={tipo}
                            onChange={(e) => setTipo(e.target.value)}
                            required
                        >
                            <option value="Error">Error</option>
                            <option value="Mejora">Mejora</option>
                        </select>
                    </form>
                </div>
                <section className="buttons-container-modal">
                    <button onClick={() => {
                        setTicket({
                            title: titulo,
                            description: descripcion,
                            type_ticket: tipo,
                            id_user: Id
                        })
                        handleSubmit()
                    }} form="form-tickets-modal">
                        Aceptar
                    </button>
                    <button type="button" onClick={closeModal}>
                        Cancelar
                    </button>
                </section>
            </Modal>
        </>
    )
}

export { Soporte }